
import * as z from 'zod';

export const novaRequisicaoSchema = z.object({
  titulo: z.string().min(1, 'Título é obrigatório'),
  descricao: z.string().optional(),
  categoria_id: z.string().min(1, 'Categoria do serviço é obrigatória'),
  urgencia: z.enum(['baixa', 'media', 'alta']),
  campos_customizados: z.record(z.any()).optional(),
});

export type NovaRequisicaoFormData = z.infer<typeof novaRequisicaoSchema>;
